import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AppBaseScreen from "../../components/AppBaseScreen";
import Rocket from "../../assets/logo/rocket.svg";
import { Box, ThemeProvider, Typography } from "@mui/material";
import { withdrawStatusTheme } from "./theme";
import SuccessComponent from "./components/Success";
import FailedComponent from "./components/Failed";
import { getWithdraw } from "../../store/api";
import { useDispatch } from "react-redux";
import { showMessageBar, updateFeedbackSurveyState } from "../../store/actions";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";

export default function WithdrawStatus() {
  const params = useParams();
  const { t } = useTranslation();
  const [status, setStatus] = useState("");
  const [withdrawData, setWithdrawData] = useState(null);
  const dispatch = useDispatch();
  const checkNullable = (value) => {
    if (
      value !== "undefined" &&
      value !== "null" &&
      value !== undefined &&
      value !== null
    ) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    const id = params?.id;
    const flag = checkNullable(id);
    if (flag) {
      // get withdraw
      getWithdrawData(id);
    } else {
      setStatus(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const getWithdrawData = async (id) => {
    try {
    const resp = await getWithdraw(id);
    setWithdrawData(resp.result);
    dispatch(updateFeedbackSurveyState(resp.result.showFeedback));

    setStatus(parseFloat(resp.result.status.toString()));
    } catch(err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
    }
  };

  const getContent = (value) => {
    switch (value) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        return <SuccessComponent withdrawData={withdrawData} />;
      case -1:
        return <FailedComponent />;
      default:
        return <FailedComponent />;
    }
  };

  if (!withdrawData && checkNullable(params.id)) {
    return (
      <AppBaseScreen isHeader={false}>
        <Box
          display={"flex"}
          flexDirection="column"
          justifyContent="center"
          alignItems={"center"}
          position={"absolute"}
          width="100%"
          height={"100%"}
          top={0}
          bottom={0}
          left={0}
        >
          <Box marginTop={10} marginBottom={20} marginLeft={"-84px"}>
            <Box className="spin" position={"absolute"}></Box>
            <Rocket style={{ width: 84, position: "absolute" }} />
          </Box>
          <Box>
            <Typography
              fontSize={16}
              textTransform={"capitalize"}
              color={"#F8FAFF"}
            >
              {t("fetching")}
            </Typography>
          </Box>
        </Box>
      </AppBaseScreen>
    );
  }
  return (
    <AppBaseScreen isHeader={false}>
      <ThemeProvider theme={withdrawStatusTheme}>{getContent(status)}</ThemeProvider>
    </AppBaseScreen>
  );
}
